// Maximum number of images allowed per note
export const MAX_NOTE_IMAGES = 5;
